/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateDisciplineReportRowDTO
 */
export interface DuplicateDisciplineReportRowDTO {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    programName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    facultyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    planCadru?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    disciplineName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    disciplineNameEN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    disciplineCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    studyYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    semester?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    duplicateCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDisciplineReportRowDTO
     */
    matchingDisciplines?: string | null;
}

export function DuplicateDisciplineReportRowDTOFromJSON(json: any): DuplicateDisciplineReportRowDTO {
    return DuplicateDisciplineReportRowDTOFromJSONTyped(json, false);
}

export function DuplicateDisciplineReportRowDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateDisciplineReportRowDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'domainName': !exists(json, 'domainName') ? undefined : json['domainName'],
        'planCadru': !exists(json, 'planCadru') ? undefined : json['planCadru'],
        'disciplineName': !exists(json, 'disciplineName') ? undefined : json['disciplineName'],
        'disciplineNameEN': !exists(json, 'disciplineNameEN') ? undefined : json['disciplineNameEN'],
        'disciplineCode': !exists(json, 'disciplineCode') ? undefined : json['disciplineCode'],
        'studyYear': !exists(json, 'studyYear') ? undefined : json['studyYear'],
        'semester': !exists(json, 'semester') ? undefined : json['semester'],
        'duplicateCount': !exists(json, 'duplicateCount') ? undefined : json['duplicateCount'],
        'matchingDisciplines': !exists(json, 'matchingDisciplines') ? undefined : json['matchingDisciplines'],
    };
}

export function DuplicateDisciplineReportRowDTOToJSON(value?: DuplicateDisciplineReportRowDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'programName': value.programName,
        'facultyName': value.facultyName,
        'domainName': value.domainName,
        'planCadru': value.planCadru,
        'disciplineName': value.disciplineName,
        'disciplineNameEN': value.disciplineNameEN,
        'disciplineCode': value.disciplineCode,
        'studyYear': value.studyYear,
        'semester': value.semester,
        'duplicateCount': value.duplicateCount,
        'matchingDisciplines': value.matchingDisciplines,
    };
}

